const _BASE_COLORS: Record<string, string> = {
  greedy: "rgb(255, 99, 132)",
  shadowprices: "rgb(255, 204, 0)",
  optimal: "rgb(0, 51, 153)",
  heuristic: "rgb(0, 156, 123)",
  heuristic0p5: "rgb(0, 210, 170)",
  repeatedilp: "rgb(255, 204, 102)",
  repeatedilp600: "rgb(255, 159, 64)",
  oblivious600: "rgb(153, 102, 255)",
  primaldual_andrews_2019: "rgb(54, 162, 235)",
};

export const STRATEGY_COLORS: Record<string, string> = Object.fromEntries(
  ["full_order", "order_splitting"].flatMap((prefix) =>
    Object.entries(_BASE_COLORS).map(([k, v]) => [`${prefix}.${k}`, v]),
  ),
);

export const STRATEGY_BACKGROUND_COLORS: Record<string, string> = Object.fromEntries(
  Object.entries(STRATEGY_COLORS).map(([k, v]) => [k, v.replace("rgb(", "rgba(").replace(")", ", 0.5)")]),
);

// legacy array-based exports for sparklingchart
export const THEME_COLORS = Object.values(_BASE_COLORS);
export const BACKGROUND_COLORS = THEME_COLORS.map((c) => c.replace("rgb(", "rgba(").replace(")", ", 0.5)"));
export const FUN_THEME_COLORS = THEME_COLORS.slice(0);
FUN_THEME_COLORS[0] = THEME_COLORS[1];
FUN_THEME_COLORS[1] = THEME_COLORS[0];
